import { render } from "./UserCenterPage.vue?vue&type=template&id=3ef6e5a0&scoped=true"
import script from "./UserCenterPage.vue?vue&type=script&lang=js"
export * from "./UserCenterPage.vue?vue&type=script&lang=js"

import "./UserCenterPage.vue?vue&type=style&index=0&id=3ef6e5a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef6e5a0"]])

export default __exports__